import { NumberUtils, Table } from 'modules';
import moment from 'moment';
import * as qs from 'qs';
import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  TableFilterInputText,
  TableFilterRangeTimeInput,
} from '../../components/table-filter-inputs';
import { TableFilterInputSelect } from '../../components/table-filter-inputs/select';
import { AdminService } from '../../services/admin';
import { OrdersOverviewLayout } from './components';

export const OrdersOverviewPage: FC = OrdersOverviewLayout((props: any) => {
  const navigate = useNavigate();
  const query = qs.parse(props.location.search, { ignoreQueryPrefix: true });

  const optionsTimeFilter = [
    { label: 'This Day', value: 'day' },
    { label: 'This Week', value: 'week' },
    { label: 'This Month', value: 'month' },
    { label: 'Custom', value: 'custom' },
  ];

  const [currentData, setCurrentData] = useState(null as any);
  const [params, setParams] = useState<any>();
  const [isShowRangeTime, setIsShowRangeTime] = useState<boolean>(
    query?.fromDate != null && query?.toDate != null ? true : false,
  );
  const [forceUpdateTable, setForceUpdateTable] = useState<boolean>();
  const [valueEmailFilter, setValueEmailFilter] = useState<any>();
  const [valueTimeFilter, setValueTimeFilter] = useState<any>(
    query?.fromDate != null && query?.toDate != null ? 'custom' : null,
  );

  return (
    <div className='page-game-orders-overview'>
      <Table
        hasOrderColumn
        className='overload'
        filters={[
          {
            name: 'Email',
            key: 'searchString',
            input: (s) => (
              <TableFilterInputText
                {...s}
                value={valueEmailFilter}
                onChange={(e) => {
                  setValueEmailFilter(e?.searchString);
                  s.onChange(e);
                }}
              />
            ),
            defaultValue: valueEmailFilter,
          },
          {
            name: 'Time',
            key: 'time',
            input: (s) => (
              <TableFilterInputSelect
                {...s}
                options={optionsTimeFilter}
                value={valueTimeFilter}
                onChange={(e) => {
                  setValueTimeFilter(e?.time);
                  s.onChange(e);
                  setForceUpdateTable((state) => !state);
                }}
                isClearable={false}
              />
            ),
            defaultValue:
              query?.fromDate != null && query?.toDate != null ? null : 'day',
          },
          {
            name: '',
            key: 'created',
            input: (s) =>
              isShowRangeTime ? (
                <TableFilterRangeTimeInput
                  {...s}
                  format='MM/dd/y'
                  fromKey='fromDate'
                  toKey='toDate'
                />
              ) : null,
            defaultValue:
              query?.fromDate != null && query?.toDate != null
                ? {
                    fromDate: moment(query?.fromDate as string).toISOString(),
                    toDate: moment(query?.toDate as string).toISOString(),
                  }
                : null,
          },
        ]}
        structure={[
          {
            name: 'UID',
            render: (item) => item?.thirdPartyUid ?? '-',
          },
          {
            name: 'Email',
            render: (item) => item?.email ?? '-',
            className: 'email',
          },
          {
            name: 'Orders Count',
            key: 'count',
            render: (item) => item?.count ?? '-',
            sort: {},
          },
          {
            name: 'Amount',
            key: 'amount',
            render: (item) =>
              NumberUtils.toFormatNumber(item?.amount, 8) ?? '-',
            sort: {},
          },
          {
            name: 'Result',
            key: 'profit',
            render: (item: any) =>
              item?.profit != null
                ? NumberUtils.toFormatNumber(item?.profit, 8)
                : '-',
            sort: {},
          },
        ]}
        fetchData={async (params) => {
          navigate(
            {
              search: undefined,
            },
            { replace: true },
          );
          setParams(params);

          if (params?.time === 'day') {
            params['fromDate'] = moment().startOf('day').toISOString();
            params['toDate'] = moment()
              .endOf('day')
              .subtract(1, 'day')
              .add(1, 'millisecond')
              .toISOString();
            setIsShowRangeTime(false);
          }
          if (params?.time === 'week') {
            params['fromDate'] = moment().startOf('isoWeek').toISOString();
            params['toDate'] = moment()
              .endOf('isoWeek')
              .subtract(1, 'day')
              .add(1, 'millisecond')
              .toISOString();
            setIsShowRangeTime(false);
          }
          if (params?.time === 'month') {
            params['fromDate'] = moment().startOf('month').toISOString();
            params['toDate'] = moment()
              .endOf('month')
              .subtract(1, 'day')
              .add(1, 'millisecond')
              .toISOString();
            setIsShowRangeTime(false);
          }

          if (params?.time === '') {
            setIsShowRangeTime(false);
            delete params.fromDate;
            delete params.toDate;
          }

          if (params?.time === 'custom') {
            if (isShowRangeTime === false) {
              delete params.fromDate;
              delete params.toDate;
            }
            setIsShowRangeTime(true);
          }

          return AdminService.getListOrdersOverview({
            page: params.pageNumber,
            pageSize: params.limit,
            ...params,
          }).then((res: any) => {
            setCurrentData(res);
            return res;
          });
        }}
        forceUpdateTable={forceUpdateTable}
      />
    </div>
  );
});
